// extracted by mini-css-extract-plugin
module.exports = {"piece":"Piece_piece__hdK0d","settings_piece":"Piece_settings_piece__PFGb4 Piece_piece__hdK0d","goast":"Piece_goast__BbMgb","opponent":"Piece_opponent__pcc6a"};